export const NoticePeriod = {
	MONTH: 'month',
	WEEK: 'week'
};
